var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItems from './parts/MenuItems';
import IconBar from './parts/IconBar';
import _, { cloneDeep } from 'lodash';
import './header.scss';
import EnhanceIcon from '../../assets/images/logo-w.png';
import CustomSelect from '../../components/common/select/select';
import WhiteDropdownIcon from '../../assets/icons/ic-dropdown-white.svg';
import DashboardIcon from '../../assets/icons/ic-dashboard.svg';
import ReportSettingIcon from '../../assets/icons/ic-report-setting.svg';
import AlertSettingIcon from '../../assets/icons/ic-bell-white.svg';
import GamSettingIcon from '../../assets/icons/auction2.svg';
import { getCurrentMenuItemPosition, getCurrentParentMenuItemPosition } from '../../store/header/reducer';
import * as LocalStorageUtil from '../../utils/LocalStorageUtil';
import { removeItem, USER_INFO_KEY, PUBLISHERS_KEY, CURRENT_MEDIA, SELECTED_PUBLISHERS_REPORT_KEY, LAST_REPORT_SETTING, PUBDESK_INVENTORIES_SELECTED, PUBLISHERS_WITHOUT_FILTER_KEY, PUBLISHERS_WITH_FILTER_KEY } from '../../utils/LocalStorageUtil';
import { TOKEN_KEY, USER_DATA_KEY, WD_SUMARY_CACHE_KEY, WD_TOP3_INCREASE_CACHE_KEY, WD_TOP3_DECREASE_CACHE_KEY } from '../../utils/StorageKeys';
import { storePublisherSelectedByCurrentUser } from '../../utils/CommonUtil';
import { useHistory } from 'react-router-dom';
import { resetUserInfo } from '../../store/authentication/actions';
import { publisherSuccess, publisherLayout, storeReportPublishers } from '../../store/publisher/actions';
import { publisherData, publisherSelectedData } from '../../store/publisher/reducer';
import { ENABLE_SELECT_PUBLISHER, DISABLE_SELECT_PUBLISHER, PLATFORM_COLORS_BY_PUBLISHER, ROLE_MEDIA_MEMBER, ROLE_ADMIN } from '../../utils/Constant';
import { CustomMultiSelect } from '../../components/common/multi-select-dropdown/MultiSelectDropdown';
import { userInfoData } from '../../store/authentication/reducer';
import { useLocation } from "react-router-dom";
import * as publisherService from '../../services/publisher-service';
var useStyles = makeStyles(function (theme) { return ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
}); });
var menuItems = [
    {
        id: 1,
        name: 'Dashboard',
        url: '#/dashboard',
        isSelected: false,
        icon: DashboardIcon,
        keyName: 'header.dashboard',
        isSelectPublisher: true,
        roles: [],
        display: true
    },
    {
        id: 2,
        name: 'Report',
        url: '#/report',
        isSelected: false,
        icon: ReportSettingIcon,
        keyName: 'header.report',
        isSelectPublisher: false,
        roles: [],
        display: true,
        parentMenus: [
            {
                name: 'Report Master',
                url: '#/report',
                isSelected: false,
                isSelectPublisher: true,
                keyName: 'header.report_master'
            },
            {
                name: 'Report Queue Management',
                url: '#/report-queue',
                isSelected: false,
                keyName: 'header.report_queue'
            },
            {
                name: 'Schedule Report',
                url: '#/schedule-report',
                isSelected: false,
                keyName: 'header.schedule_report'
            }
        ]
    },
    {
        id: 3,
        name: 'Alert',
        url: '#/alert',
        isSelected: false,
        icon: AlertSettingIcon,
        keyName: 'header.alert',
        isSelectPublisher: false,
        roles: [ROLE_MEDIA_MEMBER, ROLE_ADMIN],
        display: false
    },
    {
        id: 4,
        name: 'Bidding Management',
        url: '#/biddingNetworks',
        isSelected: false,
        icon: GamSettingIcon,
        keyName: 'header.bidding_management',
        isSelectPublisher: false,
        roles: [],
        display: false,
        parentMenus: [
            {
                name: 'Network',
                url: '#/biddingNetworks',
                isSelected: false,
                keyName: 'header.network'
            },
            {
                name: 'LineItems',
                url: '#/biddingLineItems',
                isSelected: false,
                keyName: 'header.line_items'
            }
        ]
    },
];
var Header = function (props) {
    var classes = useStyles();
    var history = useHistory();
    var isMainLayout = props.isMainLayout, publisherSelect = props.publisherSelect;
    var _a = useState(menuItems[0]), selectedMenuItem = _a[0], setSelectedMenuItem = _a[1];
    var _b = useState([]), publisherList = _b[0], setPublishers = _b[1];
    var _c = useState(), publisherItem = _c[0], setPublisher = _c[1];
    var _d = useState([]), selectedReportPublishers = _d[0], setSelectedReportPublishers = _d[1];
    var _e = useState(false), isEnableMultiplePublishers = _e[0], setEnableMultiplePublishers = _e[1];
    var _f = useState(false), isClickOutsitePublishersSelection = _f[0], setClickOutsidePublishersSelection = _f[1];
    var _g = useState(menuItems), headerMenuItems = _g[0], setHeaderMenuItems = _g[1];
    var _h = useState(false), enabledInventory = _h[0], setEnabledInventory = _h[1];
    var location = useLocation();
    // useEffect(() => {
    //   let publishers: any;
    //   const selectedMenuItemLocalStorage = LocalStorageUtil.getItem(LocalStorageUtil.CURRENT_MENU_ITEM);
    //   const selectedMenuItemTemp = selectedMenuItemLocalStorage ? JSON.parse(selectedMenuItemLocalStorage) : {};
    //   const publishersWithFilterLocalStorage = LocalStorageUtil.getItem(LocalStorageUtil.PUBLISHERS_WITH_FILTER_KEY);
    //   const publishersWithoutFilterLocalStorage = LocalStorageUtil.getItem(LocalStorageUtil.PUBLISHERS_WITHOUT_FILTER_KEY);
    //   const publishersParsed = publishersWithFilterLocalStorage ? JSON.parse(publishersWithFilterLocalStorage) : [];
    //   if (selectedMenuItemTemp && selectedMenuItemTemp?.id == 2) {
    //     publishers = publishersWithoutFilterLocalStorage;
    //   }else {
    //     publishers = publishersWithFilterLocalStorage;
    //   }
    //   if (publishers) {
    //     const publisher = getPublisherSelectedByCurrentUser();
    //     setPublisher(publisher);
    //     const publisherList = JSON.parse(publishers);
    //     setPublishers(publisherList);
    //     const publisherKey = selectedMenuItemTemp?.id == 2 ? LocalStorageUtil.PUBLISHERS_WITHOUT_FILTER_KEY : LocalStorageUtil.PUBLISHERS_WITH_FILTER_KEY;
    //     handlePublisherListData(publisherList, publisherKey, true)
    //     handleRedirectToReport(publishersParsed);
    //   } else {
    //       getPublishersByUser(selectedMenuItemTemp?.id && selectedMenuItem?.id != 2);
    //       if (selectedMenuItem?.id == 2) {
    //         getPublishersWithoutFilterByUser();
    //       }
    //     // getPublishersByUser(selectedMenuItemTemp?.id && selectedMenuItemTemp?.id != 2);
    //     // if (selectedMenuItemTemp?.id && selectedMenuItemTemp?.id == 2) {
    //     //   getPublishersWithoutFilterByUser();
    //     // }
    //   }
    // }, []);
    useEffect(function () {
        if (selectedMenuItem) {
            if (selectedMenuItem.id == 2 && publisherList && publisherList.length) {
                checkEnabledMultiplePublishers(publisherList);
            }
        }
    }, [selectedMenuItem, publisherList]);
    useEffect(function () {
        var _a, _b, _c, _d;
        var otherUrls = ['/inventories', '/api-setting', '/report-builder'];
        var hasMenuUrl = (_a = (headerMenuItems || [])) === null || _a === void 0 ? void 0 : _a.some(function (item) { var _a; return (_a = ("#" + (location === null || location === void 0 ? void 0 : location.pathname))) === null || _a === void 0 ? void 0 : _a.includes(item === null || item === void 0 ? void 0 : item.url); });
        var hasParentMenuUrl = (_b = ((selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.parentMenus) || [])) === null || _b === void 0 ? void 0 : _b.some(function (item) { var _a; return (_a = ("#" + (location === null || location === void 0 ? void 0 : location.pathname))) === null || _a === void 0 ? void 0 : _a.includes(item === null || item === void 0 ? void 0 : item.url); });
        var hasOtherUrl = (_c = (otherUrls || [])) === null || _c === void 0 ? void 0 : _c.some(function (url) { var _a; return (_a = location === null || location === void 0 ? void 0 : location.pathname) === null || _a === void 0 ? void 0 : _a.includes(url); });
        if ((selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.id) && !((_d = selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.url) === null || _d === void 0 ? void 0 : _d.includes(location === null || location === void 0 ? void 0 : location.pathname))
            && !hasMenuUrl
            && !hasParentMenuUrl
            && !hasOtherUrl)
            return;
        handleUpdatePublishers(selectedMenuItem);
    }, [selectedMenuItem]);
    useEffect(function () {
        if (props.currentMenuItemPosition) {
            var position_1 = props.currentMenuItemPosition.position ? props.currentMenuItemPosition.position : 0;
            var positionParentMenu_1 = props.currentParentMenuItemPosition && props.currentParentMenuItemPosition.position ? props.currentParentMenuItemPosition.position : 0;
            var menuJson = LocalStorageUtil.getItem(LocalStorageUtil.CURRENT_MENU_ITEM);
            var menuItem = menuJson ? JSON.parse(menuJson) : null;
            menuItems.forEach(function (menu, index) {
                if (position_1 == index) {
                    if (menuItems[index].parentMenus && menuItems[index].parentMenus.length) {
                        menuItems[index].parentMenus = menuItems[index].parentMenus.map(function (parentMenu, indexParent) {
                            if (indexParent == positionParentMenu_1) {
                                parentMenu.isSelected = true;
                                if (parentMenu.isSelectPublisher) {
                                    menuItems[index].isSelectPublisher = true;
                                }
                                else {
                                    menuItems[index].isSelectPublisher = false;
                                }
                            }
                            else {
                                parentMenu.isSelected = false;
                            }
                            return parentMenu;
                        });
                        if (menuItem && menuItem.parentMenus && menuItem.parentMenus.length) {
                            menuItem.parentMenus = menuItems[index].parentMenus;
                            menuItem.isSelectPublisher = menuItems[index].isSelectPublisher;
                        }
                    }
                    if (menuItem && menuItem.id == menuItems[index].id) {
                        onSelectedMenuItem(menuItem);
                    }
                    else {
                        onSelectedMenuItem(menuItems[index]);
                    }
                }
                else {
                    menuItems[index].isSelected = false;
                    if (menuItems[index].parentMenus && menuItems[index].parentMenus.length) {
                        menuItems[index].parentMenus = menuItems[index].parentMenus.map(function (menu) {
                            menu.isSelected = false;
                            return menu;
                        });
                    }
                }
            });
        }
    }, [props.currentMenuItemPosition]);
    var handleUpdatePublishers = function (selectedMenuItem) {
        var publishers;
        var publishersWithFilterLocalStorage = LocalStorageUtil.getItem(LocalStorageUtil.PUBLISHERS_WITH_FILTER_KEY);
        var publishersWithoutFilterLocalStorage = LocalStorageUtil.getItem(LocalStorageUtil.PUBLISHERS_WITHOUT_FILTER_KEY);
        var publishersParsed = publishersWithFilterLocalStorage ? JSON.parse(publishersWithFilterLocalStorage) : [];
        if ((selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.id) == 2) {
            publishers = publishersWithoutFilterLocalStorage;
        }
        else {
            publishers = publishersWithFilterLocalStorage;
        }
        if (publishers) {
            var publisherList_1 = JSON.parse(publishers);
            var publisherKey = (selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.id) == 2 ? LocalStorageUtil.PUBLISHERS_WITHOUT_FILTER_KEY : LocalStorageUtil.PUBLISHERS_WITH_FILTER_KEY;
            handlePublisherListData(publisherList_1, publisherKey, true);
            handleRedirectToReport(publishersParsed);
        }
        else {
            getPublishersByUser((selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.id) && (selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.id) != 2);
            if ((selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.id) == 2) {
                getPublishersWithoutFilterByUser();
            }
        }
    };
    var getPublishersByUser = function (isUpdatePublishers) { return __awaiter(void 0, void 0, void 0, function () {
        var publishers, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, publisherService.getPublisher({ includeSummaryReport: false, uiTarget: 'NEW_UI' })];
                case 1:
                    publishers = _a.sent();
                    publishers = publishers.filter(function (item) { return item.status === 'ACTIVE'; });
                    handlePublisherListData(publishers, LocalStorageUtil.PUBLISHERS_WITH_FILTER_KEY, isUpdatePublishers);
                    handleRedirectToReport(publishers);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log('getPublishersByUser', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleRedirectToReport = function (publishers) {
        var selectedMenuItemLocalStorage = LocalStorageUtil.getItem(LocalStorageUtil.CURRENT_MENU_ITEM);
        var selectedMenuItemTemp = selectedMenuItemLocalStorage ? JSON.parse(selectedMenuItemLocalStorage) : {};
        var userJson = LocalStorageUtil.getItem(LocalStorageUtil.USER_DATA);
        var user = userJson ? JSON.parse(userJson) : {};
        if ((selectedMenuItemTemp === null || selectedMenuItemTemp === void 0 ? void 0 : selectedMenuItemTemp.id) != 2 && !(publishers === null || publishers === void 0 ? void 0 : publishers.length)
            && ((user === null || user === void 0 ? void 0 : user.type) === "EXTERNAL" ||
                ((user === null || user === void 0 ? void 0 : user.type) === "INTERNAL" && (selectedMenuItemTemp === null || selectedMenuItemTemp === void 0 ? void 0 : selectedMenuItemTemp.id) == 1))) {
            history.push("/report");
        }
    };
    var getPublishersWithoutFilterByUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        var publishers, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, publisherService.getPublisher({ includeSummaryReport: false })];
                case 1:
                    publishers = _a.sent();
                    publishers = _.sortBy(publishers || [], "name");
                    publishers = publishers.filter(function (item) { return item.status === 'ACTIVE'; });
                    handlePublisherListData(publishers, LocalStorageUtil.PUBLISHERS_WITHOUT_FILTER_KEY, true);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.log('getPublishersByUser', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handlePublisherListData = function (publisherData, publisherKey, isUpdateData) {
        // if (!publisherData || !publisherData.length) return;
        var publishersWithFilterLocalStorage = LocalStorageUtil.getItem(LocalStorageUtil.PUBLISHERS_WITH_FILTER_KEY);
        var viewablePublishers = publishersWithFilterLocalStorage ? JSON.parse(publishersWithFilterLocalStorage) : [];
        var publishers = _.sortBy(publisherData, "name");
        if (publisherKey === LocalStorageUtil.PUBLISHERS_WITH_FILTER_KEY) {
            viewablePublishers = cloneDeep(publishers);
        }
        onCheckAlertFeatureEnableForPublisher(viewablePublishers, !!(viewablePublishers === null || viewablePublishers === void 0 ? void 0 : viewablePublishers.length));
        LocalStorageUtil.storeItem(publisherKey, JSON.stringify(publishers));
        if (!isUpdateData)
            return;
        if (publishers && publishers.length) {
            var foundPublisherSelected = publishers.find(function (publisher) { return publisher.selected; });
            if (!foundPublisherSelected) {
                publishers[0].selected = true;
                setPublisher(publishers && publishers.length ? publishers[0] : null);
            }
            else {
                setPublisher(foundPublisherSelected);
            }
        }
        setPublishers(publishers);
        LocalStorageUtil.storeItem(PUBLISHERS_KEY, JSON.stringify(publishers));
        LocalStorageUtil.storeItem(publisherKey, JSON.stringify(publishers));
        props.dispatch(publisherSuccess(publishers));
    };
    var onSelectedMenuItem = function (selectedItem) {
        LocalStorageUtil.storeItem(LocalStorageUtil.CURRENT_MENU_ITEM, JSON.stringify(selectedItem));
        updateSelectedMenuItem(selectedItem);
        if (selectedItem.isSelectPublisher) {
            props.dispatch(publisherLayout(ENABLE_SELECT_PUBLISHER));
        }
        else {
            props.dispatch(publisherLayout(DISABLE_SELECT_PUBLISHER));
        }
    };
    var updateSelectedMenuItem = function (selectedItem) {
        setSelectedMenuItem(selectedItem);
        // for (let i = 0; i < menuItems.length; i++) {
        //   if (menuItems[i].id === selectedItem.id) {
        //     menuItems[i].isSelected = true;
        //     if (selectedItem.parentMenus && selectedItem.parentMenus.length) {
        //       menuItems[i].parentMenus = selectedItem.parentMenus;
        //     }
        //   } else {
        //     menuItems[i].isSelected = false;
        //     if (menuItems[i].parentMenus && menuItems[i].parentMenus.length) {
        //       menuItems[i].parentMenus = menuItems[i].parentMenus.map((menu: any) => {
        //         menu.isSelected = false;
        //         return menu;
        //       });
        //     }
        //   }
        // }
        setHeaderMenuItems(function (prevState) {
            var result = (prevState || []).map(function (item) {
                if ((item === null || item === void 0 ? void 0 : item.id) === selectedItem.id) {
                    item.isSelected = true;
                    if (selectedItem.parentMenus && selectedItem.parentMenus.length) {
                        item.parentMenus = selectedItem.parentMenus;
                    }
                }
                else {
                    item.isSelected = false;
                    if (item.parentMenus && (item === null || item === void 0 ? void 0 : item.parentMenus.length)) {
                        item.parentMenus = item === null || item === void 0 ? void 0 : item.parentMenus.map(function (menu) {
                            menu.isSelected = false;
                            return menu;
                        });
                    }
                }
                return item;
            });
            return __spreadArrays(result);
        });
    };
    var onUserLogout = function () {
        removeItem(PUBDESK_INVENTORIES_SELECTED);
        removeItem(TOKEN_KEY);
        removeItem(USER_DATA_KEY);
        removeItem(USER_INFO_KEY);
        removeItem(PUBLISHERS_KEY);
        removeItem(PUBLISHERS_WITHOUT_FILTER_KEY);
        removeItem(PUBLISHERS_WITH_FILTER_KEY);
        removeItem(CURRENT_MEDIA);
        removeItem(PLATFORM_COLORS_BY_PUBLISHER);
        removeItem(SELECTED_PUBLISHERS_REPORT_KEY);
        removeItem(WD_SUMARY_CACHE_KEY);
        removeItem(LocalStorageUtil.CURRENT_MENU_ITEM);
        removeItem(LAST_REPORT_SETTING);
        removeItem(WD_TOP3_INCREASE_CACHE_KEY);
        removeItem(WD_TOP3_DECREASE_CACHE_KEY);
        var menuDashboardAndReport = [1, 2];
        menuItems.forEach(function (menu, index) {
            menuItems[index].display = menuDashboardAndReport.includes(menu.id);
        });
        props.dispatch(resetUserInfo());
        history.push("/login");
    };
    var onSelectedPublisher = function (publisher) {
        props.dispatch(storePublisherSelectedByCurrentUser([publisher]));
    };
    var onClickOutsidePublisherSelection = function () {
        setClickOutsidePublishersSelection(true);
    };
    var getSelectedPublishers = function (isMultiplePublishers, publishers) {
        if (isMultiplePublishers) {
            var storedPublishers = LocalStorageUtil.getItem(LocalStorageUtil.SELECTED_PUBLISHERS_REPORT_KEY);
            if (storedPublishers) {
                var selectedPublishers = JSON.parse(storedPublishers);
                setSelectedReportPublishers(selectedPublishers);
                props.dispatch(storePublisherSelectedByCurrentUser(selectedPublishers));
                return;
            }
        }
        if (publishers && publishers.length) {
            var selectedPublishers = [publishers[0]];
            setSelectedReportPublishers(selectedPublishers);
            props.dispatch(storePublisherSelectedByCurrentUser(selectedPublishers));
        }
    };
    var checkEnabledMultiplePublishers = function (publishers) {
        if (publishers && publishers.length) {
            var lastSettingStoreDataJson = LocalStorageUtil.getItem(LAST_REPORT_SETTING);
            if (lastSettingStoreDataJson) {
                var lastSettingStoreData_1 = JSON.parse(lastSettingStoreDataJson);
                if (lastSettingStoreData_1 && lastSettingStoreData_1.publisherIds && lastSettingStoreData_1.publisherIds.length) {
                    var publisherLastSettingReport = publishers.filter(function (publisher) {
                        var foundPublisherSelected = lastSettingStoreData_1.publisherIds.find(function (publisherId) { return publisherId == publisher.id; });
                        return foundPublisherSelected;
                    });
                    if (publisherLastSettingReport && publisherLastSettingReport.length) {
                        LocalStorageUtil.storeItem(LocalStorageUtil.SELECTED_PUBLISHERS_REPORT_KEY, JSON.stringify(publisherLastSettingReport));
                    }
                }
            }
            var isMultiplePublishers = false;
            var enabledPublisher = publishers.find(function (publisher) { return publisher && publisher.enabledMultiplePublishers; });
            isMultiplePublishers = enabledPublisher ? true : false;
            setEnableMultiplePublishers(isMultiplePublishers);
            getSelectedPublishers(isMultiplePublishers, publishers);
        }
    };
    var onSelectedPublishers = function (publishers) {
        if (!publishers || !publishers.length) {
            return;
        }
        setClickOutsidePublishersSelection(false);
        if (!_.isEqual(selectedReportPublishers, publishers)) {
            setSelectedReportPublishers(publishers);
            LocalStorageUtil.storeItem(LocalStorageUtil.SELECTED_PUBLISHERS_REPORT_KEY, JSON.stringify(publishers));
            props.dispatch(storeReportPublishers(publishers));
        }
    };
    var renderPublisherSelection = function () {
        if (!selectedMenuItem || location && location.pathname == '/inventories')
            return;
        switch (selectedMenuItem.id) {
            case 1:
                if (publisherSelect == ENABLE_SELECT_PUBLISHER) {
                    return React.createElement(CustomSelect, { defaultText: publisherItem ? publisherItem.name : "メディア切り替え", options: publisherList || [], onClick: onSelectedPublisher, dropdownStyle: "dropdown-bg-black", labelStyle: "label-white", icDropdown: WhiteDropdownIcon });
                }
                break;
            case 2:
                if (publisherSelect == ENABLE_SELECT_PUBLISHER) {
                    if (isEnableMultiplePublishers && location && location.pathname == '/report') {
                        return React.createElement(CustomMultiSelect, { defaultText: publisherItem ? publisherItem.name : "メディア切り替え", defaults: selectedReportPublishers, options: publisherList, showLabelText: true, validationChecked: true, clickOutside: isClickOutsitePublishersSelection, onClickOutside: onClickOutsidePublisherSelection, onBlur: onSelectedPublishers, dropdownStyle: "publisher-dropdown-selection", labelStyle: 'publisher-label', icDropdown: WhiteDropdownIcon, selectContainerStyle: 'publisher-select-container', isDisableClickOutside: false });
                    }
                    else {
                        return React.createElement(CustomSelect, { defaultText: publisherItem ? publisherItem.name : "メディア切り替え", options: publisherList || [], onClick: onSelectedPublisher, dropdownStyle: "dropdown-bg-black", labelStyle: "label-white", icDropdown: WhiteDropdownIcon });
                    }
                }
            default:
                break;
        }
    };
    // const getPublisherForAlertFeatureDisplay = async () => {
    //   try {
    //     const result = await publisherService.getPublisher({ includeSummaryReport: false });
    //     let publishers = _.sortBy(result, "name");
    //     publishers = publishers.filter((item: any) => item.status === 'ACTIVE')
    //     onCheckAlertFeatureEnableForPublisher(publishers);
    //   } catch (err) {
    //   }
    // }
    var onCheckAlertFeatureEnableForPublisher = function (publishers, isDisplayDashboardAndInventory) {
        var userJson = LocalStorageUtil.getItem(LocalStorageUtil.USER_DATA);
        setEnabledInventory(isDisplayDashboardAndInventory);
        if (userJson) {
            var user = JSON.parse(userJson);
            if (!user)
                return;
            if (user.type == "INTERNAL") {
                setHeaderMenuItems(function (prevState) {
                    var menuDashboard = prevState.find(function (item) { return item && item.id == 1; });
                    var menuAlert = prevState.find(function (item) { return item && item.id == 3; });
                    var menuGAM = prevState.find(function (item) { return item && item.id == 4; });
                    if (menuAlert !== undefined) {
                        menuAlert.display = true;
                    }
                    if (menuGAM !== undefined) {
                        menuGAM.display = true;
                    }
                    if (menuDashboard !== undefined) {
                        menuDashboard.display = isDisplayDashboardAndInventory;
                    }
                    return __spreadArrays(prevState);
                });
            }
            else if (user.type == 'EXTERNAL') {
                if (publishers && publishers.length) {
                    var validAlertPublishers_1 = publishers.filter(function (item) { return item && item.enabledAlertFeature; });
                    var validGAMPublishers_1 = publishers.filter(function (item) { return item && item.enabledGAMFeature; });
                    setHeaderMenuItems(function (prevState) {
                        var menuDashboard = prevState.find(function (item) { return item && item.id == 1; });
                        var menuAlert = prevState.find(function (item) { return item && item.id == 3; });
                        var menuGAM = prevState.find(function (item) { return item && item.id == 4; });
                        if (menuAlert !== undefined) {
                            menuAlert.display = (validAlertPublishers_1 && validAlertPublishers_1.length) ? true : false;
                        }
                        if (menuGAM !== undefined) {
                            menuGAM.display = (validGAMPublishers_1 && validGAMPublishers_1.length) ? true : false;
                        }
                        if (menuDashboard !== undefined) {
                            menuDashboard.display = isDisplayDashboardAndInventory;
                        }
                        return __spreadArrays(prevState);
                    });
                }
                else {
                    setHeaderMenuItems(function (prevState) {
                        var menuDashboard = prevState.find(function (item) { return item && item.id == 1; });
                        if (menuDashboard !== undefined) {
                            menuDashboard.display = isDisplayDashboardAndInventory;
                        }
                        return __spreadArrays(prevState);
                    });
                }
            }
        }
    };
    return (React.createElement("div", null,
        React.createElement(CssBaseline, null),
        React.createElement(AppBar, { position: "fixed", className: clsx(classes.appBar, "header-pubdesk") },
            React.createElement(Toolbar, null,
                !isMainLayout && React.createElement(IconButton, { color: "inherit", "aria-label": "open drawer", onClick: props.toggleSideBar, edge: "start", className: clsx(classes.menuButton, {
                    // [classes.hide]: open,
                    }) },
                    React.createElement(MenuIcon, null)),
                React.createElement("img", { src: EnhanceIcon, alt: "logo", className: "logo-pubdesk", title: "Pubdesk" }),
                React.createElement(MenuItems, { menuItems: headerMenuItems, onSelectedItem: function (data) { return onSelectedMenuItem(data); } }),
                renderPublisherSelection(),
                React.createElement(IconBar, { onUserLogout: onUserLogout, enabledInventory: enabledInventory })))));
};
function mapStateToProps(state) {
    return {
        publisherData: publisherData(state),
        currentMenuItemPosition: getCurrentMenuItemPosition(state),
        currentParentMenuItemPosition: getCurrentParentMenuItemPosition(state),
        publisherSelect: publisherSelectedData(state),
        userInfo: userInfoData(state)
    };
}
export default connect(mapStateToProps)(Header);
